import React from 'react';
import { ADMIN_ACCESS } from './PermissionsRoutes';

const Forbidden = React.lazy(() => import('pages/common/Forbidden'))
const NotFound = React.lazy(() => import('pages/common/404'))


const UserAttend = React.lazy(() => import('pages/attend/UserAttend'))

const AttendanceTag = React.lazy(() => import('pages/attend/AttendanceTag'))
const AttendanceDaily = React.lazy(() => import('pages/attend/AttendanceDaily'))
const AttendanceManagement = React.lazy(() => import('pages/attend/AttendanceManagement'))


const PF = '/attendance'
const RoutesAttendance = [
    { path: `${PF}`, exact: true, name: '근태관리', element: <UserAttend />, ...ADMIN_ACCESS },
    { path: `${PF}/management`, exact: true, name: '근태관리', element: <AttendanceManagement />, ...ADMIN_ACCESS },
    { path: `${PF}/daily`, exact: true, name: '일별 근태조회', element: <AttendanceDaily />, ...ADMIN_ACCESS },
    { path: `${PF}/tag`, exact: true, name: '출퇴근 기록 조회', element: <AttendanceTag />, ...ADMIN_ACCESS },

]

export default RoutesAttendance;
